<template>
  <div class="user ma-0">
    <v-tabs
      class="elevation-2"
      background-color="#f5f5f5"
      color="red"
      slider-size="4"
    >
      <v-tab disabled>
      </v-tab>
      <v-tab :href="`#tab-user-group`">
        {{ $t("manage.by_school.user.tab.user_groups") }}
      </v-tab>
      <v-tab :href="`#tab-user`">
        {{ $t("manage.by_school.user.tab.users") }}
      </v-tab>
      <v-tab-item :value="'tab-user-group'">
        <UserGroups />
      </v-tab-item>
      <v-tab-item :value="'tab-user'">
        <Users />
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import UserGroups from "@/components/management/user/UserGroups.vue";
import Users from "@/components/management/user/Users.vue";

export default {
  name: "user_groups",
  components: {
    UserGroups,
    Users
  },
  mixins: [],
  data: function () {
    return {
    };
  },
  mounted: function () {
    var self = this;
  },
  methods: {
  },
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>